module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-content order-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "manage-center-content"
  }, [_c('div', {
    staticClass: "manage-slide"
  }, [_c('el-col', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.defaultActive,
      "default-openeds": _vm.defaultOpen
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("下载列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'DownloadList'
      }
    }
  }, [_vm._v("下载列表")])], 1)], 2)], 2)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('router-view')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d56fd29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Download.vue
// module id = 542
// module chunks = 1